import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineCheck, AiOutlinePlus } from "react-icons/ai";
import { FaCrown } from "react-icons/fa";
import { RouteName } from "constant/routeNames";
import { Notification } from "constant/notifications";
import {
  ArtistPayload,
  CheckingFollowingStatus,
  followArtist,
} from "services/favorite/favoriteService";
import { triggerSuccessNotification } from "utils/notification";

function Followers({ followFriends }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [follow, setFollow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const targetUserId = followFriends?.id;
  const isOwnCard = loggedInUser?.id === targetUserId;
  const isPlusUser = followFriends?.is_subscribed;

  useEffect(() => {
    if (!loggedInUser || !targetUserId) return;

    CheckingFollowingStatus(targetUserId, "user")
      .then((resp) => {
        if (resp?.status === true) {
          setFollow(!!resp?.data?.data);
        }
      })
      .catch((err) => console.log("err :::", err));
  }, [loggedInUser, targetUserId]);

  const handleFollow = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!targetUserId || loading) return;

    const nextFollow = !follow;
    setFollow(nextFollow);
    setLoading(true);

    const followObject: ArtistPayload = {
      id: targetUserId,
      user_type: "user",
      is_follow: nextFollow,
    };

    followArtist(followObject)
      .then((res) => {
        if (res?.status === 200) {
          triggerSuccessNotification(
            nextFollow ? Notification.Followed : Notification.Unfollowed
          );
        }
      })
      .catch(() => setFollow(!nextFollow))
      .finally(() => setLoading(false));
  };

  return (
    <Link
      to={RouteName.UserProfile.replace("*", followFriends?.username)}
      className="group block"
    >
      <div className="relative flex min-h-[248px] w-[180px] flex-col items-center justify-start rounded-2xl border border-white/10 bg-[#141414] p-4 shadow-[0_8px_24px_rgba(0,0,0,0.35)] transition-all duration-200 hover:-translate-y-1 hover:border-[#F50537]/40 hover:shadow-[0_12px_30px_rgba(245,5,55,0.15)]">
        {/* Avatar */}
        <div className="relative">
          {isPlusUser && (
            <div className="absolute -right-1 -top-1 z-10 rounded-full bg-[#F50537] p-1.5 shadow-[0_4px_10px_rgba(245,5,55,0.5)]">
              <FaCrown className="text-[10px] text-white" />
            </div>
          )}
          <div
            className={`flex items-center justify-center rounded-full ${
              isPlusUser
                ? "bg-gradient-to-br from-[#F50537] to-red-400 p-[3px]"
                : "p-[2px] ring-1 ring-white/15"
            }`}
          >
            <img
              src={followFriends?.artwork_url}
              alt={followFriends?.name || "profile pic"}
              className="h-[92px] w-[92px] rounded-full object-cover"
            />
          </div>
        </div>

        {/* Name */}
        <p className="mt-3 line-clamp-2 w-full break-words px-1 text-center text-sm font-semibold leading-tight text-white">
          {followFriends?.name}
        </p>
        {followFriends?.username && (
          <p className="line-clamp-1 w-full break-words px-1 text-center text-[11px] font-medium text-white/40">
            @{followFriends.username}
          </p>
        )}

        {/* Follow button */}
        {!isOwnCard && (
          <button
            onClick={handleFollow}
            disabled={loading}
            className={`mt-3 flex h-[32px] w-[110px] items-center justify-center gap-1.5 rounded-full text-xs font-semibold transition-colors ${
              follow
                ? "border border-white/20 bg-white/5 text-white hover:border-[#F50537]/50 hover:bg-[#F50537]/10 hover:text-[#F50537]"
                : "bg-[#F50537] text-white hover:bg-[#d90430]"
            } ${loading ? "opacity-60" : ""}`}
          >
            {follow ? (
              <>
                <AiOutlineCheck className="text-sm" /> Following
              </>
            ) : (
              <>
                <AiOutlinePlus className="text-sm" /> Follow
              </>
            )}
          </button>
        )}
      </div>
    </Link>
  );
}

export default Followers;
